import {Provider} from '@angular/core';
import {ClientHttpProvider} from '@shared/infrastructure/http/client.http.provider';
import {LocalStorageAdapterProvider} from '@shared/infrastructure/storage/local/local.storage.adapter.provider';

import {
  ListDocumentTypesHttpAdapter
} from '@features/setting/infrastructure/http/list-document-types/list-document-types.http.adapter';
import {NavigationAdapterProvider} from '@shared/infrastructure/navigation/navigation.adapter.provider';
import {
  ListDocumentTypesUseCasePort
} from '@features/setting/application/use_cases/list-document-types/list-document-types.use-case.port';

export const ListDocumentTypesHttpProvider: Provider[] = [
  ClientHttpProvider,
  LocalStorageAdapterProvider,
  NavigationAdapterProvider,
  {
    provide: ListDocumentTypesUseCasePort,
    useClass: ListDocumentTypesHttpAdapter
  }
];
